import { schema } from "normalizr";

import { ApiModel } from "./model";

interface Dsp extends ApiModel {
    kind: "dsp";
    name?: string;
    website?: string;
    format?: string;
    status?: number;
    type?: number;
    created_at?: Date;
    updated_at?: Date;
    deleted_at?: Date;
}

// Define the normalised version of dsps.
const NDsp = new schema.Entity("dsps");

interface DspsNormalisedEntities {
    dsps?: {
        [key: number]: Dsp;
    };
}

export {
    Dsp,
    NDsp,
    DspsNormalisedEntities,
};
